import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { CompleterData, CompleterService, CompleterItem } from 'ng2-completer';
import { reportingFilter } from '../../../models/filter.model';
import { EventListenerService } from '../../../services/close-listenenr.service';
import { ReportingService } from '../../../services/reporting.service';

@Component({
  selector: 'app-filter-subsection',
  templateUrl: './filter-subsection.component.html',
  styleUrls: ['./filter-subsection.component.css']
})
export class FilterSubsectionComponent implements OnInit {

  // this references the current component as itself 
  ref: any;
  
  @Input() currentFilters: Array<reportingFilter>;
  @Input() currFiltersUsed: Array<string>

  duplicateFilter: boolean = false;

  thisFilter: reportingFilter = {
    type: '',
    value: '',
    startDate: '',
    endDate: ''
  }

  filterIdx: number = -1;

  previousFilter: string = '';
  filterType: string = '';
  dsAccountList: CompleterData;
  tempAccount: string = '';

  constructor(
    private commonService: CommonService
    , protected closeService: EventListenerService
    , private completerService: CompleterService
    , private reportingService: ReportingService
  ) { 
    this.dsAccountList = completerService.remote('api/Quote/GetAccountListByResellerRemote/',
            'out_shortname',
            'out_shortname');
  }

  ngOnInit() {
    if (this.thisFilter.type !== '')
    {
      if (!this.currFiltersUsed.includes(this.thisFilter.type))
      {
        this.currFiltersUsed.includes(this.thisFilter.type)
      }
    }
    else {
      this.currentFilters.push(this.thisFilter);
      this.filterIdx = this.currentFilters.length-1;
    }
  }

  filterSelected = () => {
    
    if (!this.currFiltersUsed.includes(this.thisFilter.type))
    {
      switch(this.thisFilter.type)
      {
        case 'ACCOUNT ID OR NAME':
          this.filterType = 'account';
          break;
        case 'OWNER':
        case 'CREATE USER':
          this.filterType = 'user';
          break;
        case 'BRAND':
        case 'REPORTING PERIOD':
        case 'QUOTE TYPE':
        case 'STATE':
          this.filterType = 'dropdown';
          break;
        case 'QUOTE ID':
        case 'VENDOR REFERENCE':
        case 'VENDOR DATA':
        case 'CUSTOMER REFERENCE':
          this.filterType = 'text';
          break;
      };
      
      if(this.previousFilter !== '')
      {
        // deletes the previous filter from the current used list
        this.currFiltersUsed.splice(this.currFiltersUsed.indexOf(this.previousFilter), 1);
      }  
      //update the current used filter list so that multiples cannot be used
      this.currFiltersUsed.push(this.thisFilter.type);
      // make the current filter as the new previous filter if it changes again
      this.previousFilter = this.thisFilter.type

      this.duplicateFilter = false;
      
    }
    else {
      this.filterType = '';
      this.thisFilter.type = '';
      this.duplicateFilter = true;
    }

  }

  onSearchKeyUp(evt: any) {
    if (this.tempAccount != null) {
        this.tempAccount = this.tempAccount.toUpperCase();
    }
  }
  
  onAccountSelected = (item: CompleterItem) => {
    if (item != null && item.originalObject != null) {
        this.thisFilter.value = item.originalObject.out_accountcode;
    }
  }

  close = () => {
    // need to remove the filter from the list using the index that we have
    this.currentFilters.splice(this.filterIdx, 1);
    // need to add the filter back into the filter list
    if (this.previousFilter !== ''){
      this.currFiltersUsed.push(this.previousFilter);
    }
    //destroy the filter instance
    this.ref.destroy();
  }

  // #region Custom Report Lists
  
  // Custom Report Filters list
  get CustomReportFilters(): Array<string>{
    return this.reportingService.customReportFilters;
  }

  get filterTimePeriods():Array<string>{
    return this.reportingService.filterTimePeriods;
  }

  get Brands(): Array<string>{
    // return this.reportingService.Brands;
    return [
      'MICROSOFT',
      'DELL',
      'LENOVO',
    ];
  }

  get States(): Array<string>{
    // if(this.commonService.isAusCompany){
      return this.reportingService.states;
    // }
    // else{
    //   return this.reportingService.statesNZ;
    // }
  }

  // #endregion
}
